<template>
  <v-card>
    <!-- {{editItem}} -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Passenger Medical</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editProjectMedicalForm" v-model="valid" lazy-validation>
        <v-layout row wrap class="pb-0">
          <v-flex md6 class="pr-1">
            <v-menu
              v-model="medicalDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editItem.medical_date"
                  label="Medical date *"
                  readonly
                  outline
                  v-on="on"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editItem.medical_date"
                @input="medicalDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md6 class="pr-1">
            <v-autocomplete
              label="Medical Status *"
              v-model="editItem.medical_status"
              :items="medicalStatuses"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-text-field
          outline
          label="Remark"
          v-model="editItem.medical_notes"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  GENDERS,
  MEDICAL_STATUSES,
  FINGER_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
  COUNTRIES,
  NATIONALITIES,
  RELIGIONS,
  MARITAL_STATUSES,
  LANGUAGES,
} from "../../mdsir/const";
import {
  getTV,
  removeEmptyProps,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem", "agents", "employers"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,

      contractDateMenu: false,
      dobDateMenu: false,
      medicalDateMenu: false,
      mofaDateMenu: false,
      trainingStartDateMenu: false,
      trainingEndDateMenu: false,
      visaIssueDateMenu: false,
      flightDateMenu: false,
      COUNTRIES: COUNTRIES,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      MARITAL_STATUSES: MARITAL_STATUSES,
      LANGUAGES: LANGUAGES,
      passportIssueDateMenu: false,
      passportExpDateMenu: false,
    };
  },
  computed: {
    medicalStatuses() {
      return getTV(MEDICAL_STATUSES);
    },
    fingerStatuses() {
      return getTV(FINGER_STATUSES);
    },
    visaTypes() {
      return getTV(VISA_TYPES);
    },
    serviceTypes() {
      return getTV(SERVICE_TYPES);
    },
    agentsTV() {
      return getTV(this.agents, { textField: "name", valueField: "id" });
    },
    employersTV() {
      return getTV(this.employers, { textField: "name", valueField: "id" });
    },
    projectOwnersTV() {
      return getTV(PROJECT_OWNER, { isDeselect: false });
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editProjectMedicalForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editProjectMedicalForm.reset();
    },
    resetValidation() {
      this.$refs.editProjectMedicalForm.resetValidation();
    },
    editItemDo() {
      if (this.$refs.editProjectMedicalForm.validate()) {
        this.actionButtonClicked = true;
        this.put(
          "/medical_details",
          removeEmptyProps(this.editItem, [
            "contract_date",
            "dob",
            "visa_issue_date",
            "flight_date",
            "medical_date",
            "mofa_date",
            "training_start_date",
            "training_end_date",
          ])
        ).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
